<div class="container">
  <div class="row mt-5">
    <div class="col-md-4 col-sm-12 mb-4" *ngFor="let whereDoIRegisterCard of whereDoIRegisterCards">
      <div class="card">
        <div class="inner-container">
          <div class="card-image-header show-image" style="height: 200px;background-image: url('{{ whereDoIRegisterCard.headImage }}');"></div>
          <div class="card-body">
            <h5 class="card-title">{{ whereDoIRegisterCard.title }}</h5>

            <p class="card-text">
              {{ whereDoIRegisterCard.body }}
              <br />
              <br />
              <br />
              &nbsp;
            </p>

            <div class="button-center">
              <a class="ba-btn" [href]="whereDoIRegisterCard.buttonUrl" role="button" target="_blank"> {{ whereDoIRegisterCard.buttonText }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
